import { Fragment, useEffect } from "react";
import Iframe from "react-iframe";

function InfoCitas() {
  useEffect(() => {
    const css = '.support-menu { display: none; }',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style');
    head.appendChild(style);
    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    return () => {
      head.removeChild(style);
    }
  }, []);

  return (
    <Fragment>
      <h1 className="sr-only">Hyundai Ecuador Citas Taller</h1>
      <Iframe
        url="https://citas.hyundai.com.ec/reserva.html"
        position="absolute"
        width="100%"
        frameBorder="0"
        height="100%"
      />
    </Fragment>
  );
}
export default InfoCitas;
